import React, { useContext, useRef } from "react";
import { StateContext } from "../../../state/index";
import BaseContent from '../../BaseContent';
import { useCustomCSS } from "../../../utils/hooks";

export const BaseAcceptView = ({ children }) => {
  const [{ configuration: {acceptPayment} }] = useContext(StateContext);
  const componentRef = useRef();
  useCustomCSS(componentRef, 'acceptPayment');

  return (
    <BaseContent {...acceptPayment} ref={componentRef}>{children}</BaseContent>
  );
};

export default BaseAcceptView;
